export function pageListener(callback) {
  if (!window) return
  const timeId = setInterval(() => {
    callback && callback()
  }, 2000)

  window.onunload = () => {
    clearInterval(timeId)
  }
  window.unbeforeunload = () => {
    clearInterval(timeId)
  }
}
